import * as fp from 'lodash/fp';
import { format, isSameDay } from 'date-fns';
import { OperatingTime, Week } from '~/types/common';

import transformDayTimeToString from '~/utils/transformDayTimeToString';

export default function getScheduleTimeString(
  operatingTime: OperatingTime,
  officialHoliday: Array<Date>,
  date: Date | null,
): string {
  if (!fp.isDate(date)) {
    return '未營業';
  }

  if(officialHoliday.some((holiday) => isSameDay(date, holiday))) {
    return '公休';
  }

  const week = format(date, 'EEE').toUpperCase() as Week;

  const dateMin = date.getHours() * 60 + date.getMinutes();

  const schedule = operatingTime[week].find(
    ({ start, end }) => fp.gte(dateMin, start) && fp.lte(dateMin, end),
  );

  if (!schedule) {
    return '未營業';
  }

  return `${transformDayTimeToString(schedule.start)}~${transformDayTimeToString(schedule.end)}`;
}
